import classNames from 'classnames';
import { bool, string } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import env from '../../../utils/env';
import * as styles from './NoSubscriptions.module.scss';

const onClickShopNow = (url) => {
  window.location = `${env.envURL}${url}`;
};

const NoSubcriptions = ({ isActiveMember = false, isBtnDisplayed = true, ctaURL }) => (
  <div
    data-testid="no-subscriptions-container"
    className={classNames(styles.container, { [styles.activeMember]: isActiveMember })}
  >
    <i className="far fa-sync" />
    <h4>{`You have no ${isActiveMember ? 'additional' : ''} subscriptions!`}</h4>
    <p>Discover new & old favorites! Subscribe and save up to 75%.</p>
    {isBtnDisplayed && (
      <div className={styles.shopNowBtnWrapper}>
        <Button onClick={() => onClickShopNow(ctaURL)}>SHOP NOW</Button>
      </div>
    )}
  </div>
);

NoSubcriptions.propTypes = {
  isActiveMember: bool,
  isBtnDisplayed: bool,
  ctaURL: string.isRequired,
};

export default NoSubcriptions;
